// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border[data-v-69d87334]{border:2px solid #fff}.border-danger[data-v-69d87334]{border:2px solid #67c23a}.el-card[data-v-69d87334]{margin-bottom:20px}.box[data-v-69d87334]{width:100%;height:120px;background:#f0f8ff}.box img[data-v-69d87334]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = exports;
